import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", amount = 0.15 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount }}
    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, light = false }) => (
  <p className={`flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.28em] ${light ? "text-gold" : "text-gold-dark"}`}>
    <span className="inline-block h-px w-8 bg-gold" aria-hidden="true"></span>
    {children}
  </p>
);

export const GoldDiamond = ({ className = "" }) => (
  <span className={`inline-block h-1.5 w-1.5 rotate-45 bg-gold ${className}`} aria-hidden="true" />
);
